import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "tickle-favorites";

const readFavorites = (): string[] => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === "string") : [];
  } catch {
    return [];
  }
};

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const isFavorite = useCallback((key: string) => favorites.includes(key), [favorites]);

  const toggleFavorite = useCallback((key: string) => {
    const current = readFavorites();
    const next = current.includes(key)
      ? current.filter((item) => item !== key)
      : [...current, key];
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // 本地存储不可用时仅保持当前状态，不阻塞页面
    }
    setFavorites(next);
    return next.includes(key);
  }, []);

  return { favorites, isFavorite, toggleFavorite };
};